import { type Observable } from '@legendapp/state';
import { createPersistedStore } from '@kidslabs/module-core';
import type { CartItemReference } from '../models';

type CartItemReferenceSelectedToProcessLogicsStoreProps = {
    usageData?: { [moduleName: string]: CartItemReference[] };
    currentData?: CartItemReference[];
};

/**
 * Cart Item Reference Selected to Process Logics store with automatic IndexedDB persistence
 *
 * ✅ Auto-registers as 'cartItemReferenceSelectedLogics'
 * ✅ No manual SSR checks needed
 * ✅ Automatic persistence on client-side
 */
export const cartItemReferenceSelectedToProcessLogicsStore$: Observable<CartItemReferenceSelectedToProcessLogicsStoreProps> =
    createPersistedStore<CartItemReferenceSelectedToProcessLogicsStoreProps>('cartItemReferenceSelectedLogics', {});
